// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqYogaMatSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqYogaMatSvg(props: Props) {
  const {fill, width = 16, height = 16} = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M2.87868 4.87868C3.44129 4.31607 4.20435 4 5 4C5.79565 4 6.55871 4.31607 7.12132 4.87868C7.68393 5.44129 8 6.20435 8 7V13C7.1396 12.3547 6.08809 12 5 12C3.91191 12 2.8604 12.3547 2 13V7C2 6.20435 2.31607 5.44129 2.87868 4.87868ZM10 7V17H8C8 16.2044 7.68393 15.4413 7.12132 14.8787C6.55871 14.3161 5.79565 14 5 14C4.20435 14 3.44129 14.3161 2.87868 14.8787C2.31607 15.4413 2 16.2044 2 17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H22V8H13H12V6H13H23H24V7V21V22H23H5C3.67392 22 2.40215 21.4732 1.46447 20.5355C0.526784 19.5979 0 18.3261 0 17V16V7C0 5.67392 0.526784 4.40215 1.46447 3.46447C2.40215 2.52678 3.67392 2 5 2C6.32608 2 7.59785 2.52678 8.53553 3.46447C9.47322 4.40215 10 5.67392 10 7Z"
        fill={fill}
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default EqYogaMatSvg;
